import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import { Icon } from '@iconify/react';
import { useState, useCallback } from 'react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { RootStyle, SearchStyle } from '../Global/Styling';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';

export default function DataToolbar({
  filterName,
  setFilterName,
  parent,
  setFilterDatesRange,
  selectStatus,
  selectStatusValue,
  setSelectStatusValue,
  setFilterParameter,
  filterParameter,
  rowInfo,
  onValidateClick,
  handleExport
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { BankDrop } = useGlobalSelector();
  const handleOpen = useCallback((e) => setAnchorEl(e.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);

  const handleRemoveFilter = useCallback(() => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectStatusValue(' ');
    setFilterName('');
    setFilterParameter({
      bankId: null
    });
  }, [setFilterDatesRange, setSelectStatusValue, setFilterName, setFilterParameter]);

  const onFilterName = useCallback(
    (event) => {
      setFilterName(event.target.value);
    },
    [setFilterName]
  );

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2} pb={1}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                disablePortal
                id="combo-box-demo8"
                options={BankDrop || []}
                size="small"
                getOptionLabel={(option) => option.label}
                renderOption={(props, option) => <li {...props}>{option.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank Name" />
                )}
                value={BankDrop?.find((item) => item.value === filterParameter?.bankId) || null}
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    bankId: newValue?.value
                  }));
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Select
                fullWidth
                size="small"
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatusValue}`
                }}
                value={selectStatusValue}
                onChange={(e) => {
                  setSelectStatusValue(e.target.value);
                }}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                <MenuItem value={selectStatus.ACTIVE.type_id}>Active</MenuItem>
                <MenuItem value={selectStatus.INACTIVE.type_id}>Inactive</MenuItem>
                <MenuItem value={selectStatus.INCOMPLETE.type_id}>Incomplete</MenuItem>
              </Select>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={1}
              display="flex"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
            >
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          bgcolor: '#ffffff'
        }}
      >
        <Box display="flex" gap={1.25} flexWrap="wrap" alignItems="center">
          <Button
            variant="contained"
            onClick={() => {
              localStorage.removeItem('reviewData');
              localStorage.removeItem('commisssionType');
              navigate(`/${parent}/add`);
            }}
            startIcon={<Icon icon={add} />}
            sx={{
              bgcolor: '#0284c7',
              color: '#ffffff',
              borderRadius: '10px',
              px: 2.2,
              py: 0.9,
              fontWeight: 600,
              fontSize: '13px',
              textTransform: 'none',
              boxShadow: '0 4px 14px rgba(2, 132, 199, 0.25)',
              '&:hover': { bgcolor: '#0369a1' }
            }}
          >
            + Add Data Source
          </Button>

          <Button
            variant="outlined"
            onClick={() => onValidateClick(rowInfo?.[0]?.id)}
            disabled={rowInfo?.length !== 1}
            startIcon={<Icon icon="material-symbols:verified-outline" />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Validate
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              localStorage.removeItem('reviewData');
              localStorage.removeItem('commisssionType');
              navigate(`/${parent}/check-bureau`);
            }}
            startIcon={<Icon icon="material-symbols:fact-check-rounded" />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Check Bureau
          </Button>

          <Button
            variant="outlined"
            onClick={handleOpen}
            startIcon={<Icon icon="mdi:export-variant" />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Export
          </Button>

          <Button
            variant="outlined"
            disabled={rowInfo?.length !== 1}
            onClick={() => {
              localStorage.removeItem('reviewData');
              localStorage.removeItem('commisssionType');
              navigate(`/${parent}/allocation`, {
                state: { rowId: rowInfo?.[0]?.id }
              });
            }}
            startIcon={<Icon icon="material-symbols:assignment-ind" />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Allocation
          </Button>

          <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
            <MenuItem onClick={() => handleExport('EXCEL')}>
              <ListItemIcon>
                <CheckCircleIcon color="success" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Export as Excel" />
            </MenuItem>

            <MenuItem onClick={() => handleExport('PDF')}>
              <ListItemIcon>
                <CancelIcon color="error" fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Export as PDF" />
            </MenuItem>
          </Menu>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          <TextField
            size="small"
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Data Source..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon={searchFill} style={{ color: '#94a3b8', fontSize: 18 }} />
                </InputAdornment>
              )
            }}
            sx={{
              width: { xs: '100%', sm: 260 },
              '& .MuiOutlinedInput-root': {
                bgcolor: '#fff',
                borderRadius: '10px',
                fontSize: '13px',
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#0284c7' }
              }
            }}
          />

          <Button
            variant="outlined"
            onClick={() => openFilter(!isOpenFilter)}
            startIcon={<Icon icon={roundFilterList} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: isOpenFilter ? '#0284c7' : '#475569',
              borderColor: isOpenFilter ? '#0284c7' : '#e2e8f0',
              bgcolor: isOpenFilter ? 'rgba(2, 132, 199, 0.06)' : '#fff',
              height: 40,
              px: 2,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.06)',
                color: '#0284c7'
              }
            }}
          >
            Filters
          </Button>
        </Box>
      </RootStyle>
    </>
  );
}
